import { createSlice } from '@reduxjs/toolkit';

export const lookupSlice = createSlice({
  name: 'lookup',
  initialState: {
    data: {},
  },
  reducers: {
    setLookupData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setLookupData } = lookupSlice.actions;

// Selector to get the entire lookup data object
export const selectLookupData = (state) => state.lookup.data;

// Selector to get a specific array by its key (dynamic)
export const selectLookupByKey = (key) => (state) => state.lookup.data[key] || [];

export default lookupSlice.reducer;
